import React from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useSnackbar } from "notistack";
import { IconButton, CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { htmlDecode } from "../../utils/convertHtml";
import { s3baseUrl } from "../../config/config";
import { styled } from "@mui/material/styles";
import { ReactVideoPlayer } from "src/components";
import { admin_videos_detail } from "src/DAL/HelpingVideos/AdminHelpingVideos";
import { useQuery } from "@tanstack/react-query";
const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

export default function HelpingVideoDetail() {
  const params = useParams();
  const navigate = useNavigate();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const ProgrammesImgStyle = styled("img")({
    width: "100%",
    height: "100%",
    objectFit: "cover",
  });
  const { data: programmesDetail = {}, isLoading } = useQuery({
    queryKey: ["helpingVideoDetail", params.slug],
    queryFn: async () => {
      const result = await admin_videos_detail(params.slug);
      if (result?.code !== 200) {
        throw new Error(result?.message);
      }
      return result;
    },
    select: (result) => result?.helping_video || {},
    onError: (error) => {
      enqueueSnackbar(error?.message, { variant: "error" });
    },
  });
  const get_programme_image = () => {
    if (programmesDetail?.program_lock_status === true) {
      return programmesDetail?.locked_program_info.image;
    } else {
      return programmesDetail?.thumbnail_image?.thumbnail_1;
    }
  };
  const get_programme_video = () => {
    if (programmesDetail?.program_lock_status === true) {
      return programmesDetail?.locked_program_info.video_url;
    } else {
      return programmesDetail?.video_url;
    }
  };

  const get_detailed_description = () => {
    if (programmesDetail?.program_lock_status === true) {
      return programmesDetail?.locked_program_info.detailed_description;
    } else {
      return programmesDetail?.long_description;
    }
  };

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }
  return (
    <div className="container-fluid">
      <div className="row mobile-margin display-flex">
        <div className="col-12">
          <IconButton
            className="back-screen-button"
            onClick={() => navigate(-1)}
          >
            <ArrowBackIcon />
          </IconButton>
        </div>
      </div>
      <div className="row ">
        <div className="col-12">
          <h2>
            {location.state
              ? htmlDecode(location.state.title)
              : htmlDecode(programmesDetail?.title)}
          </h2>
        </div>
      </div>
      <div className="row media-margin justify-content-center">
        <div className="col-sm-12 col-md-12 col-lg-9">
          {get_programme_video() ? (
            <ReactVideoPlayer url={get_programme_video()} />
          ) : get_programme_image() ? (
            <ProgrammesImgStyle src={s3baseUrl + get_programme_image()} />
          ) : (
            ""
          )}
        </div>

        <div className="col-12 section-space set-image-center">
          <div
            dangerouslySetInnerHTML={{
              __html: get_detailed_description(),
            }}
          ></div>
        </div>
      </div>
    </div>
  );
}
